import React from 'react';
import  { Container, Row, Col, Card, Form, Button,  Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from "../page-layout/loading/Loading";
import { TimerAlert } from '../../utils/swtAlert';
import { GetLookUps, GetSelectedBranches } from '../../utils/axios/LookUpAPI';
import { CreateStudents, GetStudentsById, UpdateStudents } from '../../utils/axios/StudentAPI';
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import { ORGANIZATION_TYPE, IS_GROVATOR } from "../constants/constants";


function GrovatroLabDetail(props) {
    const navigate = useNavigate();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();
    const [loading, setLoading] = useState(true);

    //Form Control Variables Starts..
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [college, setCollege] = useState("");
    const [collegelist, setCollegelist] = useState([]);
    const [branch, setBranch] = useState("");
    const [branchlist, setBranchlist] = useState([]);
    const [year, setYear] = useState("");
    const [yearlist, setYearlist] = useState([]);
    
    const [gender, setGender] = useState("");
    const [genderlist, setGenderlist] = useState([]);
    const [semester, setSemester] = useState("");
    const [semesterlist, setSemesterlist] = useState([]);
    const [email, setEmail] = useState("");
    const [course, setCourse] = useState("");
    const [courselist, setCourselist] = useState([]);
    const [mobileNumber, setMobileNumber] = useState("");
    //Form Control Variables Ends..

    const BackBtn = () => {
        navigate('/grovatorlab');
    }

    const addRefresh = () => {
        navigate('/home', {state: {studentid: null}});
    }
    const handlegrovatorlab = () => {
        navigate('/grovatorlab', {state: {studentid: null}});
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            saveGrovatoeLabStudents();
        }
    }
    
    const collegeChanged = async (e) => {
        setCollege(e.target.value);
        if(e.target.value !== "") {
            let branchesPayload = {
                OrganizationId: e.target.value
            }
            setLoading(true);
            var response = await GetSelectedBranches(branchesPayload);
            setBranchlist(response.data);
            setLoading(false);
        }
        setBranch("");
        setYear("");
        setSemester("");
        setCourse("");
    };

    const saveGrovatoeLabStudents = async () => {
        let payload = {
            OrganizationId: college,
            FirstName:  firstName,
            LastName:  lastName,
            Branch:  branch,
            Year:  year,
            Semester:  semester,
            Course:  course,
            IsGrovatorLab:  IS_GROVATOR.ASSOCIATED,
            Email:  email,
            MobileNumber:  mobileNumber,
            Gender: gender
        } 
        if (location.state.studentid != null) {
            var studentsResponse = await UpdateStudents(payload, location.state.studentid);
            if (studentsResponse.message) {
                TimerAlert('Student Updated Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Student Updated Successfully', 'success');
                setTimeout(() => navigate("/grovatorlab"), delay);
            }
        }
        else {
            var studentsResponse = await CreateStudents(payload);
            if(studentsResponse.message) {
                TimerAlert('Student Creation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Student Created Successfully', 'success');
                setTimeout(() => navigate("/grovatorlab"), delay);
            }
        }
    }
    const bindFormPreloadData = async () => {
            setLoading(true);
            //Getting All College List
            let organizationPayload = {
                OrganizationType: ORGANIZATION_TYPE.COLLEGE,
            }
            var organinizationResponse = await GetOrganization(organizationPayload);
            setCollegelist(organinizationResponse.data);
            setLoading(false);
            
            //Getting Semester List from Lookup
            let semesterpayload = {
                Type: 6
            }
            setLoading(true);
            var semesterResponse = await GetLookUps(semesterpayload);
            setSemesterlist(semesterResponse.data);
            setLoading(false);

            //Getting Year List from Lookup
            let yearpayload = {
                Type: 2
            }
            setLoading(true);
            var yearResponse = await GetLookUps(yearpayload);
            setYearlist(yearResponse.data);
            setLoading(false);

            //Getting Year List from Lookup
            let genderpayload = {
                Type: 1
            }
            setLoading(true);
            var genderResponse = await GetLookUps(genderpayload);
            setGenderlist(genderResponse.data);
            setLoading(false);

            //Getting Branch List from Lookup
            // let branchPayload = {
            //     Type: 7
            // }
            // var branchResponse = await GetLookUps(branchPayload);
            // setBranchlist(branchResponse.data);

            //Getting Branch List from Lookup
            setLoading(false);

    }
    const bindFormData = async () => {
        if(location.state.studentid !=null){
            setLoading(true);
            var response = await GetStudentsById(location.state.studentid);
            let branchesPayload = {
                OrganizationId: response.data.OrganizationId.id
            }
            var branchResponse = await GetSelectedBranches(branchesPayload);
            setBranchlist(branchResponse.data);
            setLoading(false);
            setFirstName(response.data.FirstName);
            setCollege(response.data.OrganizationId.id);
            setLastName(response.data.LastName);
            setYear(response.data.Year.id);
            setGender(response.data?.Gender?.id);
            setBranch(response.data.Branch.id);
            setSemester(response.data.Semester.id);
            setEmail(response.data.Email);
            setCourse(response.data?.Course?.id);
            setMobileNumber(response.data.MobileNumber);
        }
    }

    useEffect(() => {
        if(location.state.studentid != null){
            setIsUpdate(true);
        }
        else{
            setIsUpdate(false);
        }
        bindFormPreloadData();
        bindFormData();
        
        // document.querySelectorAll(".navbar-nav .nav-item a")[4].classList.add("active");
    }, [])

    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item onClick={() => handlegrovatorlab()}> GrovatorLab Student </Breadcrumb.Item>
                                    <Breadcrumb.Item active> GrovatorLab Student Details</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                {!isUpdate && <h2 className="page-title">Add GrovatorLab Student</h2>}
                                {isUpdate && <h2 className="page-title">Edit GrovatorLab Student</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}

                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                            <Row>
                                                <Col lg={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> <h4>GrovatorLab Student Details</h4> </Form.Label>
                                                    </Form.Group>
                                                </Col><hr/>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Associate Colleges <em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={college} onChange={collegeChanged} required >
                                                                <option value={""}>Select</option>
                                                                {collegelist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Associate College is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >First Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="FirstName" value={firstName} onChange={(e)=> setFirstName(e.target.value)} minLength={3} placeholder="Enter First Name" required />
                                                            <Form.Control.Feedback type="invalid">FirstName is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Last Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="LastName" value={lastName} onChange={(e)=> setLastName(e.target.value)} minLength={3} placeholder="Enter Last Name" required />
                                                            <Form.Control.Feedback type="invalid">LastName is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Display Name </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text"className='displayname' id="Name" value={firstName + " " + lastName} onChange={(e) =>setDisplayName(e.target.value)} readOnly/>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Gender <em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={gender} onChange={(e) => setGender(e.target.value)} required >
                                                                <option value={''}>Select</option>
                                                                {genderlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Gender is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Branch<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={branch} onChange={(e) => setBranch(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {branchlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Branch is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Year <em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={year} onChange={(e) => setYear(e.target.value)} required >
                                                                <option value={''}>Select</option>
                                                                {yearlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Year is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Semester<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={semester} onChange={(e) => setSemester(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {semesterlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Semester is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Email <em className="Required">*</em></Form.Label>
                                                        <div className='col'>
                                                            <Form.Control name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} id="email" placeholder="Enter email" required disabled/>
                                                            <Form.Control.Feedback type="invalid"> Email is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Contact Number<em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="numeric" minLength={10} maxLength={10} id="ContactNumber" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} placeholder="Enter Contact Number" required />
                                                            <Form.Control.Feedback type="invalid">Contact Number is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Row>
                                                    <Col xs={4}>
                                                        <Button variant="danger" type="button" size="sm" aria-label="small button"> Clear</Button>
                                                    </Col>
                                                    <Col>
                                                        <div className="d-flex gap justify-content-end">
                                                            <Button variant="success" size="sm" aria-label="small button" type="submit">Save</Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default GrovatroLabDetail;